import { gql, type TypedDocumentNode } from "@apollo/client";

export type EmailPreview = {
  subject: string;
  html: string;
};

export enum CommercePayorNotificationEmailType {
  INVOICE_AVAILABLE = "INVOICE_AVAILABLE",
  L1_INVOICE_AVAILABLE = "L1_INVOICE_AVAILABLE",
  INVOICE_REOPENED = "INVOICE_REOPENED",
  OPEN_ORDER_NOTIFY = "OPEN_ORDER_NOTIFY"
}

export interface CommercePayorNotificationEmailPreviewQueryResponse {
  commercePayorNotificationEmailPreview: EmailPreview;
}

export interface CommercePayorNotificationEmailPreviewQueryVariables {
  orderId: string;
  notificationType: CommercePayorNotificationEmailType;
  dueDate?: string | Date | null;
}

export const COMMERCE_PAYOR_NOTIFICATION_EMAIL_PREVIEW_QUERY: TypedDocumentNode<
  CommercePayorNotificationEmailPreviewQueryResponse,
  CommercePayorNotificationEmailPreviewQueryVariables
> = gql`
  query CommercePayorNotificationEmailPreview(
    $orderId: ID!
    $notificationType: BackofficeCommercePayorNotificationEmail!
    $dueDate: ISO8601Date
  ) {
    commercePayorNotificationEmailPreview(orderId: $orderId, notificationType: $notificationType, dueDate: $dueDate) {
      subject
      html
    }
  }
`;
